import { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import MyNexarButton from "../../../../components/button/button";
import { Form } from "./type";

interface Props {
  onUpdateSubscription: any;
  onCancelSubscription: any;
  onUpdateSubscriptionError(error: string): void;
  form: ComponentType<Form>;
  subscriptionId: string;
}

export function ActiveForm(props: Props) {
  const { t } = useTranslation();

  const {
    onUpdateSubscription,
    onCancelSubscription,
    onUpdateSubscriptionError,
    form: Form,
    subscriptionId,
  } = props;

  const footerComponent = (
    <MyNexarButton
      alt={true}
      hideOutline={true}
      action={onCancelSubscription}
      data-testid={"subscripton-form-cancel-subs"}
    >
      {t("cancelSubscription")}
    </MyNexarButton>
  );

  return (
    <Form
      status="ACTIVE"
      introText={t("yourCurrentPaymentInformationIsSavedBut")}
      footerParagraph={footerComponent}
      onSuccess={onUpdateSubscription}
      onError={onUpdateSubscriptionError}
      btnText={t("update")}
      subscriptionId={subscriptionId}
    />
  );
}

export default ActiveForm;
